import React from 'react';

import { Box } from '@mui/system';
import { IconButton, Typography } from '@mui/material';

import {
  ClientChatTypes,
  getClientTabCount,
  setChatActiveTab,
} from '@pharmaplan/common';
import styles from './styles';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import useChatSidebar from '../../../../hooks/Chat/useChatSidebar';
import { useAppSelector } from '../../../../hooks/useAppSelector';

export type IChatSidebarConfig = {
  key: ClientChatTypes;
  icon: JSX.Element;
  label: string;
  handleClick?: () => void;
};

const ChatSidebar = () => {
  const dispatch = useAppDispatch();
  const clientUnreadBarCount = useAppSelector(getClientTabCount);
  const { icons, activeTab } = useChatSidebar();

  const handleClick = (key: ClientChatTypes, customClick?: () => void) =>
    () => {
      dispatch(setChatActiveTab(key));
      customClick?.();
    };

  return (
    <Box sx={styles.container}>
      {icons.map((item) => {
        const { key, icon, label, handleClick: iconClick } = item ?? {};

        const isActive = key === activeTab;
        return (
          <IconButton
            onClick={handleClick?.(key, iconClick)}
            key={key}
            sx={[
              styles.center,
              styles.iconContainer,
              isActive && styles.isActive,
              isActive && styles.activeLabel,
            ]}
          >
            <Box sx={[styles.icon, styles.center]}>
              {!!clientUnreadBarCount[key] && <Box sx={styles.dot}>{clientUnreadBarCount[key]}</Box>}
              {icon}
            </Box>
            <Typography sx={[styles.label, isActive && styles.activeLabel]}>
              {label}
            </Typography>
          </IconButton>
        );
      })}
    </Box>
  );
};
export default ChatSidebar;
